import React from 'react'
import { View, Text, Svg, Circle, Path } from '@react-pdf/renderer'

interface HydraScoreCircleProps {
  score: any
  size: number
  text?: 'Hydra' | 'Soil'
  isDemoUser?: boolean
}

const hydraScoreColor = (hydraScore: any) => {
  if (hydraScore === 'NR') return '#808080'
  hydraScore = Number(hydraScore)
  if (hydraScore >= 93) return '#008000'
  if (hydraScore >= 79) return '#8FB935'
  if (hydraScore >= 68) return '#E6E22E'
  if (hydraScore >= 48) return '#E09C3B'
  return '#E64747'
}

const HydraScoreCircle: React.FC<HydraScoreCircleProps> = ({
  score,
  size,
  isDemoUser = false,
  text = 'Hydra',
}) => {
  const center = size / 2
  const radius = size * 0.42
  const strokeWidth = size * 0.08

  const createArc = () => {
    if (score === 'NR') return ''
    score = Number(score)
    const percentage = score / 100
    const angleOffset = -90 // Start at top
    const gapSize = 10 // Size of the gap in degrees

    const startAngle1 = angleOffset + gapSize / 2
    const endAngle1 = angleOffset + 360 * percentage - gapSize / 2

    const start1 = polarToCartesian(center, center, radius, startAngle1)
    const end1 = polarToCartesian(center, center, radius, endAngle1)

    const largeArcFlag = percentage > 0.5 ? 1 : 0

    return [
      'M',
      start1.x,
      start1.y,
      'A',
      radius,
      radius,
      0,
      largeArcFlag,
      1,
      end1.x,
      end1.y,
    ].join(' ')
  }

  const polarToCartesian = (
    centerX: number,
    centerY: number,
    radius: number,
    angleInDegrees: number
  ) => {
    const angleInRadians = (angleInDegrees * Math.PI) / 180.0
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    }
  }

  const backgroundColor = hydraScoreColor(score)

  return (
    <View style={{ width: size, height: size, position: 'relative' }}>
      <Svg width={size} height={size}>
        {/* Background circle */}
        <Circle cx={center} cy={center} r={size / 2} fill={backgroundColor} />
        {/* White progress arc */}
        <Path
          d={createArc()}
          stroke="white"
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
        />
      </Svg>
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text
          style={{
            color: 'white',
            fontSize: size * 0.13,
            lineHeight: 1,
            fontWeight: 'light',
            // marginBottom: -size * 0.02,
          }}
        >
          {text}
        </Text>
        <Text
          style={{
            color: 'white',
            fontSize: size * 0.32,
            lineHeight: 1,
            fontWeight: 'bold',
            marginVertical: -size * 0.01,
            opacity: isDemoUser ? 0.5 : 1,
          }}
        >
          {score}
        </Text>
        <Text
          style={{
            color: 'white',
            fontSize: size * 0.13,
            lineHeight: 1,
            fontWeight: 'light',
            marginTop: size * 0.04,
          }}
        >
          Score
        </Text>
      </View>
    </View>
  )
}

export default HydraScoreCircle
